import { useState } from "react";
import { Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";
import UsersActionButtons from "./UsersActionButtons";

const UsersTable = ({ data, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Id", direction: "asc" });
  const { getResizeProps } = useColumnResize();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const items = Array.isArray(data) ? data : [];

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th {...getResizeProps()}>Akcje</th>
            <th onClick={() => requestSort("IsActive")} {...getResizeProps()}>
              Aktywny {getSortArrow("IsActive")}
            </th>
            <th onClick={() => requestSort("UserRights")} {...getResizeProps()}>
              Rola {getSortArrow("UserRights")}
            </th>
            <th onClick={() => requestSort("Login")} {...getResizeProps()}>
              Login {getSortArrow("Login")}
            </th>
            <th onClick={() => requestSort("Name")} {...getResizeProps()}>
              Nazwa {getSortArrow("Name")}
            </th>
            <th {...getResizeProps()}>Jednostka DHL</th>
            <th onClick={() => requestSort("Email")} {...getResizeProps()}>
              Email {getSortArrow("Email")}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={item.id ?? item.login ?? index}>
                <td>
                  <UsersActionButtons userId={item.id} />
                </td>
                <td>{item.isActive ? "TAK" : "NIE"}</td>
                <td>{item.userRights || "—"}</td>
                <td>{item.login || "—"}</td>
                <td>{item.name || "—"}</td>
                <td>
                  {Array.isArray(item.branches) && item.branches.length > 0
                    ? item.branches
                        .map((branch) => {
                          const ex = branch?.ex ?? branch?.Ex;
                          const dr = branch?.dr ?? branch?.Dr;
                          if (ex == null || dr == null) return null;
                          return `${ex}/${dr}`;
                        })
                        .filter(Boolean)
                        .join(", ")
                    : "—"}
                </td>
                <td>{item.email || "—"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};
export default UsersTable;
